import Vue from 'vue'
import Router from 'vue-router'
import path from '../plugins/router-path'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: path.redirect
    },

    {
      path: path.home,
      name: path.home,//主界面
      meta: {serial: 0},
      components: {
        "home": resolve => require(["../components/home/home.vue"], resolve)
      }
    },

    {
      path: path.mocicle,
      name: '魔圈',
      meta: {serial: 1, anim: ''},
      components: {
        // "home": resolve => require(["../components/home/home.vue"], resolve),
        "mocicle": resolve => require(["../components/mcicle/mcicle"], resolve)
      }
    },

    {
      path: path.setting,
      name: "我的",
      meta: {serial: 1},
      components: {
        // "home": resolve => require(["../components/home/home.vue"], resolve),
        "other": resolve => require(["../components/setting/setting.vue"], resolve)
      }
    },

    {
      path: path.Find,
      name: '发现',
      meta: {serial: 1},
      components: {
        // "home": resolve => require(["../components/home/home.vue"], resolve),
        "other": resolve => require(["../components/find/find.vue"], resolve)
      }
    },

    {
      path: path.publish,
      name: '发布',
      meta: {serial: 1, anim: ''},
      components: {
        // "home": resolve => require(["../components/home/home.vue"], resolve),
        "other": resolve => require(["../components/publish/publish.vue"], resolve)
      }
    },

    {
      path: path.publishRPDetail,
      name: path.publishRPDetail,
      meta: {serial: 1, anim: ''},
      components: {
        /*"home": resolve => require(["../components/home/home.vue"], resolve),*/
        "other": resolve => require(["../components/publish/publish-detail-rp"], resolve)
      }
    },

    {
      path: path.publishRecord,
      name: '发布记录',
      meta: {serial: 1, anim: ''},
      components: {
        // "home": resolve => require(["../components/home/home.vue"], resolve),
        "other": resolve => require(["../components/publish/publish-record"], resolve)
      }
    },

    {
      path: path.settingSet,
      name: "设置",
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/setting-setting.vue"], resolve)
      }
    },
    {
      //个人主页
      path: path.profile,
      name: path.profile,
      meta: {serial: 5},
      components: {
        "other": resolve => require(["../components/common/user-profile.vue"], resolve)
      }
    },

    {
      //别人的主页
      path: path.othersProfile,
      name: path.othersProfile,
      meta: {serial: 6},
      components: {
        "other": resolve => require(["../components/common/others-profile.vue"], resolve)
      }
    },

    {
      path: path.infoModify,
      name: path.infoModify,
      meta: {serial: 6},
      components: {
        "other": resolve => require(["../components/setting/info-modify.vue"], resolve)
      }
    },

    {
      path: path.ownInfo,
      name: '个人信息',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/own-info.vue"], resolve)
      }
    },

    {
      path: path.wallet,
      name: '钱包',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/wallet.vue"], resolve)
      }
    },
    {
      path: path.walletRecord,
      name: '钱包记录',
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/setting/wallet-record.vue"], resolve)
      }
    },

    {
      path: path.walletAliModify,
      name: '支付宝修改',
      meta: {serial: 4},
      components: {
        "other": resolve => require(["../components/setting/wallet-ali-modify.vue"], resolve)
      }
    },

    {
      path: path.walletCash,
      name: '提现申请',
      meta: {serial: 4},
      components: {
        "other": resolve => require(["../components/setting/wallet-cash"], resolve)
      }
    },

    {//好友 -  聊天 界面
      path: path.mochat,
      name: '好友/聊天',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/mochat/mochat.vue"], resolve)
      }
    },

    {//好友请求详情
      path: path.FriendRequestInfo,
      name: path.FriendRequestInfo,
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/mochat/friend-request-info.vue"], resolve)
      }
    },
    {
      path: path.mochatDialogue,
      name: path.mochatDialogue,
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/dialogue/dialogue"], resolve)
      }
    },
    {
      path: path.AddFrind,
      name: '添加好友',
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/mochat/addfrind.vue"], resolve)
      }
    },
    {
      path: path.mochatGroupMgr,
      // name: '群聊信息',
      name: path.mochatGroupMgr,
      meta: {serial: 4},
      components: {
        "other": resolve => require(["../components/dialogue/chat-group-set"], resolve)
      }
    },

    {
      path: path.mochatSingleMgr,
      name: '单聊信息',
      meta: {serial: 4},
      components: {
        "other": resolve => require(["../components/dialogue/chat-single-set"], resolve)
      }

    },

    {
      path: path.mochatGroupAlbums,
      name: '群相册',
      meta: {serial: 5},
      components: {
        "other": resolve => require(["../components/dialogue/chat-group-albums"], resolve)
      }
    },


    {
      path: path.publishRedPacket,
      name: '红包发布',
      meta: {serial: 2, anim: ''},
      components: {
        "other": resolve => require(["../components/publish/publish-red.vue"], resolve)
      }
    },
    {
      path: path.PublishLocationSet,
      name: '红包选择位置',
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/publish/publish-location-set"], resolve)
      }
    },
    {
      path: path.systemRPDetail,
      name: path.systemRPDetail,
      meta: {serial: 1, anim: ''},
      components: {
        "other": resolve => require(["../components/home/system-packet"], resolve)
      }
    },


    {
      path: path.publishWish,
      name: '发布有偿愿望',
      meta: {serial: 2, anim: ''},
      components: {
        "other": resolve => require(["../components/publish/publish-wish"], resolve)
      }

    },
    {
      path: path.publishFree,
      name: '发布无偿愿望',
      meta: {serial: 2, anim: ''},
      components: {
        "other": resolve => require(["../components/publish/publish-free"], resolve)
      }
    },
    {
      path: path.mcicleList,
      name: path.mcicleList,//订单详情
      meta: {serial: 2, anim: ''},
      components: {
        "other": resolve => require(["../components/mcicle/mcicle-detail"], resolve)
      },
    },
    {
      path: path.FreeDesire,
      name: path.FreeDesire,
      meta: {serial: 3},
      components: {
        "other": resolve => require(["../components/publish/Free-desire.vue"], resolve)
      }
    },
    {
      path: path.MyOrder,
      name: '我的订单',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/myorder.vue"], resolve)
      },
      children: [
        {
          name: '订单详情',
          path: 'detail',
          component: resolve => require(["../components/setting/order-detail.vue"], resolve),
          children: [
            {
              name: '确认完成',
              path: 'confirm-finish',
              component: resolve => require(["../components/setting/confirm-finish.vue"], resolve)
            }
          ]
        },
      ]
    },
    // {
    //   path: path.OrderDetail,
    //   name: '订单详情',
    //   meta: {serial: 3},
    //   components: {
    //     "other": resolve => require(["../components/setting/order-detail.vue"], resolve)
    //   }
    // },
    {
      path: path.Revenue,
      name: '收益',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/find/revenue.vue"], resolve),
      }
    },
    //
    // {
    //   path: path.requests,
    //   name: '好友请求',
    //   meta:{serial: -1},
    //   component: resolve => require(["../components/contact/requests.vue"], resolve),
    // },
    //
    // {
    //   path: path.groupChats,
    //   name: '群聊列表',
    //   meta:{serial: -1},
    //   component: resolve => require(["../components/contact/group-chats.vue"], resolve),
    // },
    //

    //
    // {
    //   path: path.infoModify,
    //   name: '信息修改',
    //   meta:{serial: -1},
    //   component: resolve => require(["../components/setting/info-modify.vue"], resolve),
    // },
    //


    {
      path: path.login,
      name: '登录',
      meta: {serial: 1},
      components: {
        "other": resolve => require(["../components/account/login.vue"], resolve)
      }
    },
    {
      path: path.register,
      name: '注册',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/account/register.vue"], resolve)
      }
    },
    {
      path: path.phoneReset,
      name: '手机号重置',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/account/reset-phone.vue"], resolve)
      }
    },
    {
      path: path.phoneBind,
      name: '绑定手机号',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/account/bind-phone.vue"], resolve)
      }
    },
    {
      path: path.pwdReset,
      name: '密码重置',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/account/reset-pwd.vue"], resolve)
      }
    },
    /* 本地假无偿*/
    {
      path: path.LocalPublis,
      name: path.LocalPublis,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/publish/pubilsh-local.vue"], resolve)
      }
    },
    {
      path: path.SharePage,
      name: path.SharePage,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/share/share-page.vue"], resolve)
      }
    },
    {
      path: path.RealName,
      name: '实名认证',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/real-name.vue"], resolve)
      }
    },
    {
      path: path.RealCard,
      name: path.RealCard,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/real-card.vue"], resolve)
      }
    },
    {
      path: path.CardSuccess,
      name: '上传身份证成功',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/card-success.vue"], resolve)
      }
    },
    {
      path: path.Ament,
      name: '修改手机号',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/account/ament.vue"], resolve)
      }
    },
    {
      path: path.Advertise,
      name: '启动页广告详情页',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/home/startadvertise.vue"], resolve)
      }
    },
    {
      path: path.Citylist,
      name: '城市列表',
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/publish/Citylist.vue"], resolve)
      }
    },
    {
      path: path.Friendinformation,
      name: path.Friendinformation,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/mochat/friendinformation.vue"], resolve)
      }
    },
    {
      path: path.OrderDesire,
      name: path.OrderDesire,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/setting/orderdesire.vue"], resolve)
      }
    },
    {
      path: path.SelectLike,
      name: path.SelectLike,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/common/select-like.vue"], resolve)
      }
    },
    {
      path: path.GuidePage,
      name: path.GuidePage,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/common/guide-page.vue"], resolve)
      }
    },
    {
      path: path.Recipe,
      name: path.Recipe,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/find/recipe.vue"], resolve)
      }
    },
    {
      path: path.Qrcode,
      name: path.Qrcode,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/find/qrcode.vue"], resolve)
      }
    },
    {
      path: path.Invite,
      name: path.Invite,
      meta: {serial: 2},
      components: {
        "other": resolve => require(["../components/find/invite.vue"], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js